module.exports = __webpack_public_path__ + "static/media/GPS.95bdf5f6.png";